import Vue from 'vue'
import Print from 'vue-print-nb'
import * as filters from '@/utils/filter'
import * as prototype from '@/utils/prototype'

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

Vue.use(Print)

// 挂载原型方法
Object.assign(Vue.prototype, prototype)

// 注册全局过滤器
Object.entries(filters).forEach(([name, filter]) => {
  Vue.filter(name, filter)
})

// 全局组件
import AsideNavSlot from '@/components/layout/slot/AsideNavSlot'
import AsideAdSlot from '@/components/layout/slot/AsideAdSlot'
import manyboVerifyCode from '@/components/public/manybo-verifyCode'
import manyboGap from '@/components/public/manybo-gap'
import manyboTurnstile from '@/components/public/manybo-turnstile'
import manyboSection from '@/components/public/manybo-section'
import manyboLoadMore from '@/components/public/manybo-loadMore'
import manyboPageHeader from '@/components/public/manybo-pageHeader'
import manyboPasswordInput from '@/components/public/manybo-passwordInput.vue'

Vue.component('AsideNavSlot', AsideNavSlot)
Vue.component('AsideAdSlot', AsideAdSlot)
Vue.component('manyboVerifyCode', manyboVerifyCode)
Vue.component('manyboGap', manyboGap)
Vue.component('manyboSection', manyboSection)
Vue.component('manyboLoadMore', manyboLoadMore)
Vue.component('manyboPageHeader', manyboPageHeader)
Vue.component('manyboTurnstile', manyboTurnstile)
Vue.component('manyboPasswordInput', manyboPasswordInput)